import { AccountActivationState } from '@pbl/pbl-react-core/lib/models/account-activation';
import { ReactivationState } from '@pbl/pbl-react-core/lib/models/account-reactivation';
import { ActivityStateType } from '@pbl/pbl-react-core/lib/models/activity/types';
import { AppState, CLEAR_APP_STATE } from '@pbl/pbl-react-core/lib/models/app';
import { DrawDetailState } from '@pbl/pbl-react-core/lib/models/draws/types';
import { IFeatureState } from '@pbl/pbl-react-core/lib/models/feature-flagging';
import { ScratchGamesUnclaimedPrizeState, UnclaimedPrizeState} from '@pbl/pbl-react-core/lib/models/games/types';
import { LoyaltyState } from '@pbl/pbl-react-core/lib/models/loyalty/types';
import { PasswordChangeState } from '@pbl/pbl-react-core/lib/models/password';
import { PasswordResetState } from '@pbl/pbl-react-core/lib/models/password-reset';
import { PreferencesState } from '@pbl/pbl-react-core/lib/models/preferences';
import { IProfileState } from '@pbl/pbl-react-core/lib/models/profile/types';
import { TicketState } from '@pbl/pbl-react-core/lib/models/ticket/types';
import { UserRegistrationState } from '@pbl/pbl-react-core/lib/models/user-registration/types';
import AccountActivation from '@pbl/pbl-react-widgets/lib/redux/reducers/account-activation/reducers';
import AccountReactivation from '@pbl/pbl-react-widgets/lib/redux/reducers/account-reactivation/reducers';
import App from '@pbl/pbl-react-widgets/lib/redux/reducers/app/reducers';
import Authentication, { AuthState } from '@pbl/pbl-react-widgets/lib/redux/reducers/authentication/reducers';
import Activity from '@pbl/pbl-react-widgets/lib/redux/reducers/activity/reducers';
import DrawDetail from '@pbl/pbl-react-widgets/lib/redux/reducers/draws/draw-detail.reducer';
import Draws, { DrawsState } from '@pbl/pbl-react-widgets/lib/redux/reducers/draws/reducers';
import Feature from '@pbl/pbl-react-widgets/lib/redux/reducers/feature/reducers';
import InteractiveGames, { InteractiveGamesState } from '@pbl/pbl-react-widgets/lib/redux/reducers/interactive-games/reducers';
import GameUnclaimedPrizes from '@pbl/pbl-react-widgets/lib/redux/reducers/lotto-unclaimed-prizes/reducers';
import Loyalty from '@pbl/pbl-react-widgets/lib/redux/reducers/loyalty/reducers';
import OptOutPreferences, { OptOutState } from '@pbl/pbl-react-widgets/lib/redux/reducers/opt-out/reducers';
import PasswordReset from '@pbl/pbl-react-widgets/lib/redux/reducers/password-reset/reducers';
import PasswordChange from '@pbl/pbl-react-widgets/lib/redux/reducers/password/reducers';
import Preferences from '@pbl/pbl-react-widgets/lib/redux/reducers/preferences/reducers';
import Profile from '@pbl/pbl-react-widgets/lib/redux/reducers/profile/reducers';
import ScratcherUnclaimedPrizes from '@pbl/pbl-react-widgets/lib/redux/reducers/scratcher-unclaimed-prizes/reducers';
import PromotionSuperBonus, { PromotionSuperBonusState } from '@pbl/pbl-react-widgets/lib/redux/reducers/super-bonus/reducers';
import Ticket from '@pbl/pbl-react-widgets/lib/redux/reducers/ticket/reducers';
import UserRegistration from '@pbl/pbl-react-widgets/lib/redux/reducers/user-registration/reducers';
import { combineReducers } from 'redux';
import { PersistPartial } from 'redux-persist/lib/persistReducer';
import Reward from '@pbl/pbl-react-widgets/lib/redux/reducers/rewards/reducer';
import { RewardState } from '@pbl/pbl-react-core/lib/models/reward/types';
import Games, { GamesState } from 'redux/reducers/games/reducers';
export type GetStateMethod = () => IRootState;

export interface IDispatchAction {
  type: string;
  payload?: any;
}

export type DispatchMethod = (object: IDispatchAction) => void;

export interface IRootState {
  app: AppState;
  accountActivation: AccountActivationState;
  accountReactivation: ReactivationState;
  authentication: AuthState & PersistPartial;
  draws: DrawsState;
  drawDetail: DrawDetailState;
  feature: IFeatureState;
  interactiveGames: InteractiveGamesState;
  loyalty: LoyaltyState;
  optOutPreferences: OptOutState;
  passwordChange: PasswordChangeState;
  passwordReset: PasswordResetState;
  profile: IProfileState & PersistPartial;
  promotionSuperBonus: PromotionSuperBonusState;
  userRegistration: UserRegistrationState;
  ticket: TicketState;
  preferences: PreferencesState;
  gameUnclaimedPrizes: UnclaimedPrizeState;
  scratcherUnclaimedPrizes: ScratchGamesUnclaimedPrizeState;
  activityState: ActivityStateType & PersistPartial;
  reward: RewardState;
  games: GamesState;
}

const appReducer: (state: IRootState, action: IDispatchAction) => IRootState = combineReducers<
  // @ts-ignore
  IRootState
>({
  app: App,
  accountActivation: AccountActivation,
  accountReactivation: AccountReactivation,
  authentication: Authentication,
  draws: Draws,
  drawDetail: DrawDetail,
  feature: Feature,
  interactiveGames: InteractiveGames,
  loyalty: Loyalty,
  optOutPreferences: OptOutPreferences,
  passwordChange: PasswordChange,
  passwordReset: PasswordReset,
  profile: Profile,
  promotionSuperBonus: PromotionSuperBonus,
  userRegistration: UserRegistration,
  ticket: Ticket,
  preferences: Preferences,
  gameUnclaimedPrizes: GameUnclaimedPrizes,
  scratcherUnclaimedPrizes: ScratcherUnclaimedPrizes,
  activityState: Activity,
  reward: Reward,
  games: Games
});

const reducer = (state: IRootState, action: IDispatchAction): IRootState => {
  if (action.type === CLEAR_APP_STATE) {
    state = {} as IRootState;
  }

  return appReducer(state, action);
};

export default reducer;
